module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/GEOLOGY-EARTH SCIENCES-dfbf6359ea8265b69f679807bcc63cae.png";